var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 73,
    r: 73,
    fill: "#EB0029"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108 52.875V70.7249C108 75.1699 106.53 78.915 103.905 81.505C101.315 84.13 97.57 85.5999 93.125 85.5999V91.9349C93.125 94.3149 90.465 95.75 88.505 94.42L85.11 92.1799C85.425 91.0949 85.565 89.9049 85.565 88.6449V74.4001C85.565 67.2601 80.805 62.5 73.665 62.5H49.9C49.41 62.5 48.955 62.5351 48.5 62.5701V52.875C48.5 43.95 54.45 38 63.375 38H93.125C102.05 38 108 43.95 108 52.875Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.565 74.4001V88.6449C85.565 89.9049 85.425 91.0949 85.11 92.1799C83.815 97.3249 79.545 100.545 73.665 100.545H64.145L53.575 107.58C52 108.665 49.9 107.51 49.9 105.62V100.545C46.33 100.545 43.355 99.355 41.29 97.29C39.19 95.19 38 92.2149 38 88.6449V74.4001C38 67.7501 42.13 63.1651 48.5 62.5701C48.955 62.5351 49.41 62.5 49.9 62.5H73.665C80.805 62.5 85.565 67.2601 85.565 74.4001Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.29a882e5ea45025a462c59aa86653b85.svg";
export { ForwardRef as ReactComponent };